import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import './hr.css';
import './ta.css';
import './hrrc.css';
import './hre.css';
import { HRProvider } from './HRContext';
import { HR_BASE, HR_MODULE, findGroup, findSubmodule, hrSubUrl, tabOf } from './catalog';
import { GroupTabs, SubTabs } from './components/Cards';
import Register from './components/Register';
import { RESOURCES } from './resources';
import * as Screens from './screens';
import Icon from './Icon';
import ModuleCard from '../components/ModuleCard';

// HR & People routes:
//   /hr-people           hub: one card per submenu, as the Cost Control and Inventory hubs (also the old ?all link)
//   /hr-people/g/:group  that submenu's first tab (the sidebar's submenu links)
//   /hr-people/s/:sub    a sub-module, under its submenu's tab bar

function HubPage() {
  const navigate = useNavigate();
  return (
    <div className="fade-in">
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: '0 0 22px' }}>Select an {HR_MODULE.title} module below.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 18 }}>
        {HR_MODULE.groups.map(g => (
          <ModuleCard key={g.key} item={{ id: `hr-${g.key}`, label: g.title, description: g.description }} color={g.color}
                      icon={<Icon name={g.icon} size={24} />} onOpen={() => navigate(hrSubUrl(g.tabs?.[0] || g.submodules[0].key))} />
        ))}
      </div>
    </div>
  );
}

function GroupPage() {
  const { groupKey } = useParams();
  const group = findGroup(groupKey);
  if (!group) return <Navigate to={HR_BASE} replace />;
  return <Navigate to={hrSubUrl(group.tabs?.[0] || group.submodules[0].key)} replace />;
}

function SubmodulePage() {
  const { subKey } = useParams();
  const found = findSubmodule(subKey);
  if (!found) return <Navigate to={HR_BASE} replace />;
  const { group, sub } = found;

  let body;
  if (sub.view === 'register') {
    const res = RESOURCES[sub.resource];
    body = res ? <Register key={sub.key} res={res} filter={sub.filter} /> : <div className="error">Register {sub.resource} is missing</div>;
  } else if (sub.view === 'report') {
    body = <Screens.Report key={sub.key} report={sub.report} />;
  } else {
    const Cmp = Screens[sub.screen];
    body = Cmp ? <Cmp key={sub.key} sub={sub} /> : <div className="error">Screen {sub.screen} is missing</div>;
  }

  // a sub-page sits under its parent's tab; a tab with subtabs shows them as a second bar (Stephanet's SubmodulePage)
  const activeTab = tabOf(sub);
  const host = group.submodules.find(s => s.key === activeTab);
  const inner = (host?.subtabs || []).map(k => group.submodules.find(s => s.key === k)).filter(Boolean);

  return (
    <>
      {group.tabs?.includes(activeTab) && <GroupTabs group={group} active={activeTab} />}
      {/* no breadcrumb or description line here: the top bar names the page and the tabs place it.
          The content sits in the same thick frame as Payment Voucher and Enterprise Requisition. */}
      <div style={{ background: 'var(--bg-card, #fff)', border: '3px solid black', borderRadius: 16, minHeight: 400, padding: 24, boxShadow: 'var(--shadow-sm)' }}>
        <SubTabs items={inner} active={sub.key} />
        {body}
      </div>
    </>
  );
}

export default function HRApp({ user, toast }) {
  return (
    <HRProvider user={user} toast={toast}>
      <div className="hr-scope">
        <Routes>
          <Route index element={<HubPage />} />
          <Route path="g/:groupKey" element={<GroupPage />} />
          <Route path="s/:subKey" element={<SubmodulePage />} />
          <Route path="*" element={<Navigate to={HR_BASE} replace />} />
        </Routes>
      </div>
    </HRProvider>
  );
}
